import request from '@/utils/request'

export function save(data) {
    return request({
      url: 'admin/data/fwusersubscribe/save',
      method: 'post',
      data
    })
  }
  export function query(data) {
    return request({
      url: 'admin/data/fwusersubscribe/queryBy',
      method: 'post',
      data
    })
  }